export default "__VITE_ASSET__C26NY2bU__"